import { CommonDialogs } from "@mcleod/common";
import { ClickEvent, Table, TableSelectionEvent, Toast } from "@mcleod/components";
import { getDispatchControlBoolean } from "@mcleod/general";
import { RowDriverOnlyFields } from "../../../asset/src/models/autogen/AutogenModelDriverOnly";
import { Preassignment, PreassignmentSlideoutProps } from "../../asset/Preassignment";
import { AutogenLayoutLoadMatchToolPanel } from "./autogen/AutogenLayoutLoadMatchToolPanel";

export class LoadMatchToolPanel extends AutogenLayoutLoadMatchToolPanel {

    private table: Table;
    private driverData: Partial<RowDriverOnlyFields>;
    private tractorId?: string;
    private equipmentGroupId: string;

    public initialize(driverData: Partial<RowDriverOnlyFields>, driverRemoteAccess: boolean, equipmentGroupId: string, tractorId?: string) {
        this.table = this.owner?.getTable(this.id);
        this.table?.addSelectionListener((event: TableSelectionEvent) => {
            this.tableOnSelect(event);
        });

        this.driverData = driverData;
        this.equipmentGroupId = equipmentGroupId;
        this.tractorId = tractorId;

        this.buttonDecline.visible = getDispatchControlBoolean("enable_remote_driver_choice");
        if (this.buttonDecline.visible) this.buttonDecline.visible = driverRemoteAccess;
        this.visible = true;
    }

    private async tableOnSelect(event: TableSelectionEvent) {
        const modelRow = event.newRow?.data;
        this.buttonDecline.enabled = modelRow != null;
        this.buttonPreassignLoad.enabled = modelRow != null;
    }

    private buttonDeclineOnClick(event: ClickEvent) {
        CommonDialogs.showMessage("Functionality coming soon");
    }

    private buttonPreassignOnClick(event: ClickEvent) {
        const modelRow = this.table?.selectedRow?.data;
        if (modelRow == null) return;

        const moveId = modelRow.get("movement_id");
        const orderId = modelRow.get("order_id");
        const props: PreassignmentSlideoutProps = {
            driver1Data: this.driverData,
            tractor: this.tractorId,
            movementId: moveId,
            orderId: orderId,
            preassigned: false,
            equipmentGroupId: this.equipmentGroupId,
            loadMatchLock: true,
            doAfterSlideout: async (name: string, showToast: boolean) => {
                if (showToast) {
                    await this.owner?.slideOut(); // Close LoadMatch after assignment
                    Toast.showToast(Preassignment.getResultsToastPanel(orderId, name));
                }
            }
        };

        props.sourceEvent = event;
        Preassignment.showSlideout(props);
    }

}
